import React from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import Frame from '../img/icons/Frame.svg';
import Vector3 from '../img/icons/Vector(3).svg';
import Vector from '../img/icons/Vector.svg';
import { bookedFilte, inputChange } from '../redux/fliteBooking/actions';
import BookigList from './BookigList';

const Bookings = () => {

    
   

    const bookigs = useSelector((state) => state.flitebooking.bookingInfo);
    const dispatch = useDispatch();

  

    const handleBooking = (e) => {
        e.preventDefault();

      
        if( Object.values(bookigs).every(Boolean)){

            dispatch(bookedFilte(bookigs))
          

        }else{
            toast.error('please fill all the inputs')
        }

      }
      
  return (
    <section>
    {/* Input Data */}
    <div className="mt-[160px] mx-4 md:mt-[160px] relative">
      <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
        <form className="first-hero lws-inputform" onSubmit={handleBooking}>
          {/* From */}
          <div className="des-from">
            <p>Destination From</p>
            <div className="flex flex-row">
              <img src={Frame} alt />
              <select className="outline-none px-2 py-2 w-full" value={bookigs.from}  name="from" id="lws-from" required  onChange={(e)=>dispatch(inputChange(e))}>
                <option value hidden>Please Select</option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox's Bazar</option>
              </select>
            </div>
          </div>
          {/* To */}
          <div className="des-from">
            <p>Destination To</p>
            <div className="flex flex-row">
              <img src={Frame} alt />
              <select className="outline-none px-2 py-2 w-full" value={bookigs.to}  name="to" id="lws-to" required  onChange={(e)=>dispatch(inputChange(e))}>
                <option value hidden>Please Select</option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox's Bazar</option>
              </select>
            </div>
          </div>
          {/* Date */}
          <div className="des-from">

            <p>Journey Date</p>
            <input type="date" value={bookigs.date}  className="outline-none px-2 py-2 w-full date" name="date" id="lws-date"   onChange={(e)=>dispatch(inputChange(e))}/>
          </div>
          {/* Guests */}
          <div className="des-from">
            <p>Guests</p>
            <div className="flex flex-row">
              <img src={Vector} alt />
              <select className="outline-none px-2 py-2 w-full" value={bookigs.guests}  name="guests" id="lws-guests" onChange={(e)=>dispatch(inputChange(e))}  required>
                <option value hidden>Please Select</option>
                <option value={1}>1 Person</option>
                <option value={2}>2 Persons</option>
                <option value={3}>3 Persons</option>
                <option value={4}>4 Persons</option>
              </select>
            </div>
          </div>
          {/* Class */}
          <div className="des-from !border-r-0">
            <p>Class</p>
            <div className="flex flex-row">
              <img src={Vector3} alt />
              <select className="outline-none px-2 py-2 w-full" value={bookigs.ticketClass}  name="ticketClass" id="lws-ticketClass" required onChange={(e)=>dispatch(inputChange(e))}> 
                <option value hidden>Please Select</option>
                <option>Business</option>
                <option>Economy</option>
              </select>
            </div>
          </div>
          <button className="addCity" type="submit" id="lws-addCity" >
            <svg width="15px" height="15px" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            <span className="text-sm">Book</span>
          </button>
        </form>
      </div>
    </div>
    {/* Preview Data */}
   <BookigList/>
  </section>
  )
}

export default Bookings